import { useEffect, useState } from "preact/hooks";
import fetchGroup from "./fetchGroup";

/**
 *
 * @param {tag|gid} group Group tag (`group:xyz`), or product id `gid://shopify/Product/12345`
 * @returns [groupData]
 */
export default function useProductGroup(group) {
  const [groupData, setGroupData] = useState([]);

  useEffect(() => {
    if (!group) return;

    fetchGroup(group).then(setGroupData);
  }, [group]);

  return [groupData];
}
